import { z } from 'zod';
/** Central control for customer TXT quiet hours (Jacky, 30 September 2026): a message approved
 *  between `quiet_from` and `quiet_until` (Sydney wall clock) is queued and leaves at `quiet_until`.
 *  Installers and suppliers are not customers; add them to `audiences` to hold theirs too. */
const HHMM = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'HH:MM on the Sydney clock');
export const SmsQuietHoursSchema = z.object({
    enabled: z.boolean(),
    quiet_from: HHMM,
    quiet_until: HHMM,
    audiences: z.array(z.enum(['customer', 'supplier', 'installer'])).min(1),
}).refine(v => v.quiet_from !== v.quiet_until, { message: 'quiet_from and quiet_until must differ' });
export const smsQuietHoursDefaults = { enabled: true, quiet_from: '21:00', quiet_until: '08:00', audiences: ['customer'] };
//# sourceMappingURL=sms-quiet-hours.js.map